import { cn } from '~/lib/cn';

export interface CellProps {
  children?: React.ReactNode;
  className?: string;
}

function TableTh(props: CellProps): JSX.Element {
  return (
    <th
      className={cn(
        'min-w-[12em] px-lg py-sm text-left align-bottom text-body-sm font-normal text-default',
        props.className,
      )}
    >
      {props.children}
    </th>
  );
}

TableTh.displayName = 'TableTh';

function TableTd(props: CellProps): JSX.Element {
  return (
    <td
      className={cn(
        'overflow-hidden whitespace-nowrap px-lg py-xs text-body-sm',
        props.className,
      )}
    >
      {props.children}
    </td>
  );
}

TableTd.displayName = 'TableTd';

export { TableTd, TableTh };
